import React from 'react';
import { PhoneIconRound } from '@cp/ds/src/icons/social';
import { ButtonProps, ButtonTemplate } from './button';

export const PhoneButton = (props: ButtonProps) => (
  <ButtonTemplate {...props}>
    <PhoneIconRound /> Телефон
  </ButtonTemplate>
);
